// @flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Array } from '@mzvonar/modular-redux-form';
import { Shape } from '../../../types';
import Points from './Points';


const useStyles = makeStyles({
    addPointButton: {
        float: 'right'
    }
});

export type Props = $ReadOnly<{
    name: string,
    shape: Shape,

    inputChange: (name: string, value: mixed) => void,
    setShape: (shape: Shape) => void
}>;

function Polygon({ name, shape, inputChange, setShape }: Props) {
    const classes = useStyles();

    const addPoint = () => {
        setShape({
            ...shape,
            coordinates: [
                ...shape.coordinates,
                []
            ]
        });
    };

    const removePoint = (index: number) => {
        const newCoordinates = shape.coordinates.slice();
        newCoordinates.splice(index, 1);

        setShape({
            ...shape,
            coordinates: newCoordinates
        });
    };

    const onPointChange = (index: number, point: [number, number]) => {
        const coordinates = shape.coordinates.slice();
        coordinates.splice(index, 1, point);

        setShape({
            ...shape,
            coordinates: coordinates
        });
    };

    return (
        <div>
            <Array
                name={`${name}.coordinates`}
                component={Points}
                points={shape.coordinates}
                minLength={3}
                inputChange={inputChange}
                setShape={setShape}
                removePoint={removePoint}
                onPointChange={onPointChange}
            />

            <IconButton className={classes.addPointButton} onClick={addPoint}>
                <AddCircleIcon />
            </IconButton>
        </div>
    );
}

export default Polygon